module.exports = __webpack_public_path__ + "img/logo.949bfd32.png";